import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from './locales/en.json'
import br from './locales/pt-br.json'

const resources = { en, br }

i18n.use(initReactI18next)
  .init({
    lng: window.navigator.language === "en" ? "en" : "pt-br",
    resources,
    defaultNS: "common",
    fallbackLng: "br",
  });

export { i18n };